import React from 'react';
import { Form, Select, DatePicker, Input, Button, Row, Col } from 'antd';
// import moment from 'moment';

const { RangePicker } = DatePicker;

const TransactionFilter = ({
  onFilterChange,
  warehouses,
  categories,
  types,
  grnSearchQuery,
  ginSearchQuery,
  customerSearchQuery,
  productSearchQuery,
  selectedWarehouse,
  selectedCategory,
  selectedType,
  specificDate,
}) => {
  const handleSubmit = (values) => {
    onFilterChange(values);
  };

  const handleReset = () => {
    onFilterChange({
      warehouse: null,
      category: null,
      type: null,
      specificDate: null,
      dateRange: null,
      grnSearchQuery: '',
      ginSearchQuery: '',
      customerSearchQuery: '',
      productSearchQuery: '',
    });
  };


  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item label="Warehouse">
            <Select
              placeholder="Select Warehouse"
              value={selectedWarehouse}
              onChange={(value) => onFilterChange({ warehouseId: value })}
              allowClear
            >
              {warehouses?.map((warehouse) => (
                <Select.Option key={warehouse._id} value={warehouse._id}>
                  {warehouse.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="Category">
            <Select
              placeholder="Select Category"
              value={selectedCategory}
              onChange={(value) => onFilterChange({ categoryId: value })}
              allowClear
            >
              {categories?.map((category) => (
                <Select.Option key={category._id} value={category._id}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="Type">
            <Select
              placeholder="Select Type"
              value={selectedType}
              onChange={(value) => onFilterChange({ transactionType: value })}
              allowClear
            >
              {types?.map((type) => (
                <Select.Option key={type} value={type}>
                  {type}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="Specific Date">
            <DatePicker
              format="YYYY-MM-DD"
              value={specificDate }
              onChange={(date, dateString) => onFilterChange({ specificDate: dateString })}
              allowClear
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={6}>
          <Form.Item label="Date Range">
            <RangePicker
              format="YYYY-MM-DD"
              onChange={(dates, dateStrings) => onFilterChange({ dateRange: dateStrings })}
              allowClear
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="GRN Search">
            <Input
              placeholder="Search by GRN"
              value={grnSearchQuery}
              onChange={(e) => onFilterChange({ grnSearchQuery: e.target.value })}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="GIN Search">
            <Input
              placeholder="Search by GIN"
              value={ginSearchQuery}
              onChange={(e) => onFilterChange({ ginSearchQuery: e.target.value })}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item label="Customer Search">
            <Input
              placeholder="Search by Customer"
              value={customerSearchQuery}
              onChange={(e) => onFilterChange({ customerSearchQuery: e.target.value })}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={6}>
          <Form.Item label="Product Search">
            <Input
              placeholder="Search by Product"
              value={productSearchQuery}
              onChange={(e) => onFilterChange({ productSearchQuery: e.target.value })}
            />
          </Form.Item>
        </Col>

        <Col span={6} offset={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Form.Item>
            {/* <Button type="primary" htmlType="submit">
              Apply Filters
            </Button> */}
            <Button style={{ marginLeft: '8px' }} onClick={handleReset}>
              Reset Filters
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default TransactionFilter; 